<template>
  <ItemPage
    title="Segmentos"
    size="sm"
    :actions="actions"
  >
    <template
      v-if="gradeLevelGroupsView"
    >
      <v-simple-table fixed-header>
        <template v-if="loading">
          <Load :loadingmsg="loadingMsg" />
        </template>
        <div
          v-else
        >
          <v-data-table
            :headers="headers"
            :items="contents"
            :items-per-page="10"
            :search="search"
            item-key="id"
            @click:row="editGradeLevelGroup($event)"
          />
        </div>
      </v-simple-table>
    </template>
    <template v-else>
      usuário sem permissão
    </template>
  </ItemPage>
</template>

<script>
import Load from '@/components/Loading.vue'
import GenericFormDialog from '@/components/settings/GenericFormDialog.vue'
import utils from '@/api/utils.js'
import ItemPage from '@/components/pages/ItemPage.vue'

export default {
  components: {
    Load,
    ItemPage
  },
  data () {
    return {
      gradeLevelGroupsView: false,
      gradeLevelGroupsCreate: false,
      loading: false,
      loadingMsg: '',
      request: false,
      dialogAddGradeLevelGroup: false,
      renderComponent: 0,
      contents: [],
      search: '',
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'id'
        },
        {
          text: 'Nome',
          align: 'start',
          value: 'name'
        },
        {
          text: 'Abreviatura',
          align: 'start',
          value: 'short_name'
        },
        {
          text: 'Ordem',
          align: 'start',
          value: 'order'
        }
      ]
    }
  },
  computed: {
    actions () {
      return [
        {
          label: 'Adicionar segmentos',
          action: this.openGenericFormDialog,
          icon: 'mdi-plus',
          disabled: !this.gradeLevelGroupsCreate
        }
      ]
    }
  },
  created () {
    this.fetchAll()
  },
  methods: {
    fetchAll () {
      this.getGradeLevelGroup()
      this.gradeLevelGroupsView = utils.checkPermissions('grade-level-groups.view-any')
      this.gradeLevelGroupsCreate = utils.checkPermissions('grade-level-groups.create')
    },
    async getGradeLevelGroup () {
      this.loading = true
      this.loadingMsg = 'Carregando Lista...'
      try {
        const content = await this.$api.getGradeLevelGroups()
        this.contents = content
      } catch {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível obter segmentos, tente novamente mais tarde.', color: 'red' })
      }
      this.loading = false
    },
    editGradeLevelGroup (event) {
      this.$router.push({ name: 'segmentos.id', params: { id: event.id } })
    },
    openGenericFormDialog () {
      this.$dialog.custom(GenericFormDialog).with({ title: 'segmento' }).show()
        .then((gradeLevelGroup) => {
          if (!gradeLevelGroup) {
            return
          }
          this.newGradeLevelGroup(gradeLevelGroup)
        })
    },
    async newGradeLevelGroup (data) {
      data.order = 0
      this.loadingMsg = 'Salvando...'
      try {
        await this.$api.newGradeLevelGroup(data)
        this.$store.dispatch('setSnackBar', { text: 'Salvo com sucesso.' })
        this.fetchAll()
      } catch {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível salvar, tente novamente mais tarde.', color: 'red' })
      }
      this.request = false
    }
  }
}
</script>
